import { useNavigate } from 'react-router-dom';
import useAppContext from 'core/hooks/app-context';
import PageRoute from 'core/page-route';
import useMakePaymentLogic from './use-make-payment.logic';
import { DialogId, useComponentContext, useDialog, useGotoRecurringPayment } from '../index';
import { SetupStep } from '../recurring-payment-component.store';
import { useSetupTranslations } from '../translations';

const useSetupLogic = () => {
  const navigate = useNavigate();

  const context = useComponentContext();
  const redirecting = context.redirecting;

  const appStore = useAppContext();

  const setup = useSetupTranslations();
  const paymentLogic = useMakePaymentLogic(false);
  const gotoRecurringPayment = useGotoRecurringPayment();

  const dialog = {
    confirmSetup: useDialog(DialogId.confirmSetup),
    setupConfirmation: useDialog(DialogId.setupConfirmation),
    paymentIframe: useDialog(DialogId.paymentIframe),
  }

  const showQuoteSummary = () => {
    dialog.confirmSetup.close();
    context.changeSetupStep(SetupStep.quoteSummary);
  }

  const handlePaymentError = (error: any) => {
    redirecting.close();
    context.showError(setup.failure.text, setup.failure.heading);
  }

  const confirmSetup = async () => {
    dialog.confirmSetup.close();
    redirecting.open();

    try {
      await paymentLogic.makePayment(handlePaymentError);
    } catch (error) {
      handlePaymentError(error);
    }
  }

  const receiveCardDetails = async (event: MessageEvent) => {
    try {
      await paymentLogic.receiveCardDetails(event);
    } catch (error) {
      console.error(event, error);
      handlePaymentError(error);
    }
  }

  return {
    // showIntro: () => store.changeSetupStep(SetupStep.intro),

    showConfirm: () => {
      dialog.confirmSetup.open()
    },

    closeConfirm: () => {
      redirecting.close();
      dialog.confirmSetup.close();
    },

    showQuoteSummary,
    // showQuoteSummaryBreakdown: () => context.changeSetupStep(SetupStep.quoteSummaryBreakdown),
    gotoViewBalance: () => navigate(PageRoute.account.viewBalance),

    confirmSetup,
    receiveCardDetails,

    chatToAnAgent: () => {
      appStore.changeOpenLiveChat(true);
      dialog.setupConfirmation.close()
      gotoRecurringPayment();
    },
  };
}

export default useSetupLogic;